import { render, staticRenderFns } from "./EventCancellationPolicy.vue?vue&type=template&id=38fc72ff&"
import script from "./EventCancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./EventCancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports